module.exports = __webpack_public_path__ + "static/amazon-b98e976e2b39b0a22f1bcc9e9ee48f1f.png";